import React from "react";
import Logo2 from "../components/edata.png";

function Home() {
  return (
    <div className="home2">
      <img className="img2" src={Logo2} style={{ width: '300px', height: 'auto' }} />
      <footer>Versão 26.02</footer>
    </div>
  );
}

export default Home;
